import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import ERPDataGrid from "../ERPDataGrid";
import "../ERPTheme.css";
import {baseUrl, ipAddress, userName} from "../Univ";
function StockTransaction() {
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [items, setItems] = useState([]);
    const [editId, setEditId] = useState(null);
    const transactionTypes = [{
        value: "OPENING", label: "Opening"
    }, {
        value: "PURCHASE", label: "Purchase"
    }, {
        value: "SALE", label: "Sale"
    }, {
        value: "RETURN_IN", label: "Return In"
    }, {
        value: "RETURN_OUT", label: "Return Out"
    }, {
        value: "TRANSFER_IN", label: "Transfer In"
    }, {
        value: "TRANSFER_OUT", label: "Transfer Out"
    }, {
        value: "PRODUCTION", label: "Production"
    }, {
        value: "CONSUMPTION", label: "Consumption"
    }, {
        value: "DAMAGE", label: "Damage"
    }, {
        value: "ADJUSTMENT", label: "Adjustment"
    }];
    const [formData, setFormData] = useState({
        item: "",
        transaction_type: "",
        quantity: "",
        rate: "",
        reference_no: "",
        remarks: "",
        transaction_date: ""
    });
    useEffect(() => {
        getTransactions();
        getItems();
    }, []);
    const getTransactions = () => {
        setLoading(true);
        axios.get(baseUrl + "stock-transaction/")
            .then((res) => {
                setRows(res.data);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });
    };
    const getItems = () => {
        axios.get(baseUrl + "inventory-item/")
            .then((res) => {
                setItems(res.data);
            });
    };
    const handleChange = (e) => {
        const {name, value} = e.target;
        let updated = {
            ...formData, [name]: value
        };
        if (name === "quantity" || name === "rate") {
            updated.total = Number(updated.quantity || 0) * Number(updated.rate || 0);
        }
        setFormData(updated);
    };
    const clearForm = () => {
        setEditId(null);
        setFormData({
            item: "",
            transaction_type: "",
            quantity: "",
            rate: "",
            reference_no: "",
            remarks: "",
            transaction_date: ""
        });
    };
    const editData = (row) => {
        setEditId(row.id);
        setFormData({
            item: row.item.id,
            transaction_type: row.transaction_type,
            quantity: row.quantity,
            rate: row.rate,
            reference_no: row.reference_no,
            remarks: row.remarks,
            transaction_date: row.transaction_date
        });
    };
    const deleteData = (id) => {
        Swal.fire({
            title: "Delete Stock Transaction?", icon: "warning", showCancelButton: true
        })
            .then((result) => {
                if (result.isConfirmed) {
                    axios.delete(`delete-stock-transaction/${id}/`)
                        .then(() => {
                            Swal.fire("Deleted", "", "success");
                            getTransactions();
                        });
                }
            });
    };
    const saveData = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const data = new FormData();
            data.append("item", formData.item);
            data.append("transaction_type", formData.transaction_type);
            data.append("quantity", formData.quantity);
            data.append("rate", formData.rate);
            data.append("reference_no", formData.reference_no);
            data.append("remarks", formData.remarks);
            data.append("transaction_date", formData.transaction_date);
            data.append("addedby", userName);
            data.append("ip_add", ipAddress);
            if (editId === null) {
                await axios.post(baseUrl + "stock-transaction/", data);
            } else {
                await axios.put(baseUrl + `update-stock-transaction/${editId}/`, data);
            }
            Swal.fire("Success", editId === null ? "Stock Transaction Saved" : "Stock Transaction Updated", "success");
            clearForm();
            getTransactions();
        } catch (error) {
            Swal.fire("Error", "Unable to Save Transaction", "error");
        }
        setLoading(false);
    };
    const columns = [{

    field: "item",
    headerName: "Item",
    width: 200,
    renderCell: (params) => (
        <span>
            {params.row.item?.item_name}
        </span>
    )
    }, {
        field: "transaction_type", headerName: "Type", width: 150
    }, {
        field: "quantity", headerName: "Quantity", width: 120
    }, {
        field: "rate", headerName: "Rate", width: 120
    }, {
        field: "total", headerName: "Total", width: 120
    }, {
        field: "transaction_date", headerName: "Date", width: 150
    }, {
        field: "reference_no", headerName: "Reference", width: 150
    }, {
        field: "action", headerName: "Action", width: 180, renderCell: (params) => (<>


                <button


                    className="btn btn-success btn-sm me-2"


                    onClick={() => editData(params.row)}


                >


                    Edit


                </button>


                <button


                    className="btn btn-danger btn-sm"


                    onClick={() => deleteData(params.row.id)}


                >


                    Delete


                </button>


            </>)
    }];
    return (<div className="container-fluid mt-3">


            <div className="card shadow">


                <div className="card-header bg-success text-white">


                    <h5 className="mb-0">

                        Stock Transaction

                    </h5>


                </div>


                <div className="card-body">


                    <form onSubmit={saveData}>


                        <div className="row">


                            <div className="col-md-3 mb-3">


                                <label>

                                    Item

                                </label>


                                <select


                                    className="form-control"


                                    name="item"


                                    value={formData.item}


                                    onChange={handleChange}


                                    required


                                >


                                    <option value="">


                                        Select Item


                                    </option>


                                    {items.map((item) => (<option


                                            key={item.id}


                                            value={item.id}


                                        >


                                            {item.item_name}


                                        </option>))}


                                </select>


                            </div>


                            <div className="col-md-3 mb-3">


                                <label>

                                    Transaction Type

                                </label>


                                <select


                                    className="form-control"


                                    name="transaction_type"


                                    value={formData.transaction_type}


                                    onChange={handleChange}


                                    required


                                >


                                    <option value="">


                                        Select Type


                                    </option>


                                    {transactionTypes.map((item) => (<option


                                            key={item.value}


                                            value={item.value}


                                        >


                                            {item.label}


                                        </option>))}


                                </select>


                            </div>


                            <div className="col-md-2 mb-3">


                                <label>

                                    Quantity

                                </label>


                                <input


                                    type="number"


                                    step="0.01"


                                    className="form-control"


                                    name="quantity"


                                    value={formData.quantity}


                                    onChange={handleChange}


                                    required


                                />


                            </div>


                            <div className="col-md-2 mb-3">


                                <label>

                                    Rate

                                </label>


                                <input


                                    type="number"


                                    step="0.01"


                                    className="form-control"


                                    name="rate"


                                    value={formData.rate}


                                    onChange={handleChange}


                                />


                            </div>



                            <div className="col-md-3 mb-3">


                                <label>

                                    Reference No

                                </label>


                                <input


                                    type="text"


                                    className="form-control"


                                    name="reference_no"


                                    value={formData.reference_no}


                                    onChange={handleChange}


                                />


                            </div>


                            <div className="col-md-3 mb-3">


                                <label>

                                    Transaction Date

                                </label>


                                <input


                                    type="date"


                                    className="form-control"


                                    name="transaction_date"


                                    value={formData.transaction_date}


                                    onChange={handleChange}


                                    required


                                />


                            </div>


                            <div className="col-md-6 mb-3">


                                <label>

                                    Remarks

                                </label>


                                <textarea


                                    className="form-control"


                                    rows="2"


                                    name="remarks"


                                    value={formData.remarks}


                                    onChange={handleChange}


                                />


                            </div>


                            <div className="col-md-12 mt-3">


                                <button


                                    type="submit"


                                    className="btn btn-success me-2"


                                    disabled={loading}


                                >


                                    {editId === null ? "Save Transaction" : "Update Transaction"}


                                </button>


                                <button


                                    type="button"


                                    className="btn btn-secondary"


                                    onClick={clearForm}


                                >


                                    Clear


                                </button>


                            </div>


                        </div>


                    </form>


                </div>


            </div>

            <div className="card shadow mt-3">


                <div className="card-header bg-primary text-white">


                    <h5 className="mb-0">

                        Stock Transaction List

                    </h5>


                </div>


                <div className="card-body">


                    <div

                        style={{
                            height: 600, width: "100%"
                        }}

                    >


                        <ERPDataGrid


                            rows={rows}


                            columns={columns}


                            loading={loading}


                            getRowId={(row) => row.id}


                            pageSizeOptions={[10, 25, 50, 100]}

                            disableRowSelectionOnClick


                        />


                    </div>


                </div>


            </div>


        </div>);
}
export default StockTransaction;